import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import difference from 'lodash/difference'

import { withSettings } from '../withSettings'
import { isPremium } from '../../../../../utils/plans'

import Form from '../Form'
import Toggle from '../Form/toggle'
import RoutingTypeChooser from './RoutingTypeChooser'
import PremiumLabel from '../Form/PremiumLabel'

@inject('users', 'websites')
@withSettings
@observer
export default class WebsiteLeadsRouting extends Component {
  website = this.props.websites.current

  choosers = new Map()

  getRoutingSettings() {
    const admin = this.props.users.find(u => u.admin)
    return this.props.getSettingsAt('lead_routing', {
      round_robin_disabled: [],
      routes: [
        { type: 'Event::Message',    source: 'listing:info',     title: 'Listing: Request Info',  mode: 'Manual', user_id: admin.id, notify: true },
        { type: 'Event::Message',    source: 'listing:tour',     title: 'Listing: Request Tour',  mode: 'Manual', user_id: admin.id, notify: true },
        { type: 'Event::Message',    source: 'form:contact',     title: 'Contact Form',           mode: 'Manual', user_id: admin.id, notify: true },
        { type: 'Event::Message',    source: 'form:cma',         title: 'Home Valuation Request', mode: 'Manual', user_id: admin.id, notify: true },
        { type: 'Event::Registered', source: 'registration',     title: 'Website Registration',   mode: 'Manual', user_id: admin.id, notify: true },
        { type: 'Event::Registered', source: 'listing:comment',  title: 'Comments',               mode: 'Manual', user_id: admin.id, notify: true },
        { type: 'Event::Registered', source: 'listing:reaction', title: 'Reactions',              mode: 'Manual', user_id: admin.id, notify: true },
        { type: 'Event::Registered', source: 'listing:save',     title: 'Saved Listings',         mode: 'Manual', user_id: admin.id, notify: true },
        { type: 'Event::Registered', source: 'search:save',      title: 'Search Subscriptions',   mode: 'Manual', user_id: admin.id, notify: true }
      ]
    })
  }

  routingTypeChooserRef = route => chooser => {
    this.choosers.set(route, chooser)
  }

  handleData = data => {
    const routes = []
    for (const [route, chooser] of this.choosers) {
      routes.push({ ...route, ...chooser.getState() })
    }

    let roster = data.roster
    if (!roster) roster = []
    if (!Array.isArray(roster)) roster = [roster]
    delete data.roster

    data.round_robin_disabled = difference(this.props.users.map(u => u.id), roster.map(id => Number(id)))
    return this.props.setSettingsAt('lead_routing', { ...data, routes })
  }

  render() {
    const { users } = this.props
    if (!users.loaded) return (
      <div className="loading">Loading...</div>
    )
    const { round_robin_disabled = [], routes, notify_cc_email, allow_separating_search_party, skip_agent_id } = this.getRoutingSettings()

    return (
      <div className="container padded settings">
        <Form onData={this.handleData}>
          <div className="panel full padded">
            <h2 className="title">Lead Routing</h2>

            <div style={{marginBottom: '15px', textAlign: 'center'}}>
              <PremiumLabel>Round Robin Routing Available On Premium Plan Only</PremiumLabel>
            </div>
            
            <div className="form-section">
              <table>
                <thead>
                  <tr>
                    <th style={{textAlign: 'left'}}>Source</th>
                    <th style={{textAlign: 'left'}}>Routing Type</th>
                    <th style={{textAlign: 'left', width: '416px'}}>Assignee</th>
                  </tr>
                </thead>
                <tbody className="padded">
                  {routes.map(route => (
                    <RoutingTypeChooser 
                      ref={this.routingTypeChooserRef(route)} 
                      key={route.source} 
                      premium={isPremium(this.website.plan)}
                      {...route} />
                  ))}
                </tbody>
              </table>
            </div>

            <div className="form-section">
              <h3 className="title">Distribution Settings</h3>
              <label htmlFor="notify_cc_email">Forward a copy of all incoming leads to this email address:</label>
              <input type="text" id="notify_cc_email" name="notify_cc_email" defaultValue={notify_cc_email}/>
            </div>

            <div className="form-section">
              <Toggle name="allow_separating_search_party" on={allow_separating_search_party}>
                Allow members of same search party to be assigned to different agents.
              </Toggle>
            </div>

            <div className="form-section">
              <Toggle name="skip_agent_id" on={skip_agent_id}>
                Do not consider the listing's agent when assigning leads.
              </Toggle>
            </div>

            <div className="form-section">
              <h3 className="title">Round Robin Roster</h3>
              <p className="muted">Select which users you want to recieve leads for Round Robin routing:</p>
              {users.map(user => (
                <label key={user.id}>
                  <input type="checkbox" name="roster" value={user.id} defaultChecked={!round_robin_disabled.includes(user.id)}/>
                  {user.name}
                </label>
              ))}
            </div>
          </div>
          <button type="submit" className="big shadowed">Save Changes</button>
        </Form>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// client/components/sections/website/settings/LeadRouting/index.js